export default function FilterTree({ renderItems }) {
  return <div className="hitq-items-container">{renderItems()}</div>;
}
